import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    versionPage_title: 'Версия МП',
    versionPage_errorLoad: 'Не удалось получить версию',
    versionPage_errorSet: 'Не удалось обновить версию',
    versionPage_errorValidation: 'Введите версию правильно например 1.0.0',
    versionPage_androidVersion: 'Версия андроид',
    versionPage_iosVersion: 'Версия IOS',
    versionPage_critical: 'Обновление обязательно',
    versionPage_save: 'Сохранить'
  },
  kk: {
    versionPage_title: 'МП нұсқасы',
    versionPage_errorLoad: 'Нұсқаны жүктеу сәтсіз аяқталды',
    versionPage_errorSet: 'Нұсқаны жаңарту сәтсіз аяқталды',
    versionPage_androidVersion: 'Android нұсқасы',
    versionPage_iosVersion: 'iOS нұсқасы',
    versionPage_critical: 'Жаңарту міндетті',
    versionPage_save: 'Сақтау'
  }
});
